import { createTheme } from "@mui/material";

declare module "@mui/material/styles" {
  interface Palette {
    borderColor: string;
  }

  interface PaletteOptions {
    borderColor: string;
  }
}

const borderColor = "#D7D7D7";

const theme = createTheme({
  palette: {
    borderColor,
    divider: borderColor,
  },
  typography: {
    button: {
      textTransform: "none",
    },
    fontFamily: ["Inter"].join(","),
    h1: {
      fontSize: "24px",
      fontWeight: "600",
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiChip: {
      styleOverrides: {
        colorWarning: {
          backgroundColor: "#F2C94C",
        },
        colorSuccess: {
          backgroundColor: "#08BA4F33",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderColor,
        },
      },
    },
  },
});

export default theme;
